const expireSession = (
  $location,
  $rootScope,
  $window,
  appErrorHandler,
  appSession,
) => {
  'ngInject';

  const removeUnauthorizedEvent = appSession.onSessionUnauthorizedToken(() => {
    appSession.signout()
    .catch((error) => {
      appErrorHandler.handle(error, '', true);
    })
    .then(() => {
      $window.location.href = '/login?expired=true';
    });
  });

  const removeInterruptedEvent = appSession.onSessionInterrupted(() => {
    $window.location.href = '/login';
  });

  $rootScope.$on('$destroy', () => {
    removeUnauthorizedEvent();
    removeInterruptedEvent();
  });
};

export default expireSession;
